import { request } from '@langlois/request';

export async function subscribe ({ commit, dispatch }, { instanceId, planId }) {
	commit(`setSubscription`, {});

	const url = new URL(`${process.env.VUE_APP_API_URI}/club/subscription`);

	let response;

	try {
		response = await request.post(url, {
			instanceId,
			planId
		});

		const { ok, status } = response;

		if (!ok) {
			if (status === 409) {
				return await dispatch(`getBySubscriberId`, { instanceId });
			}

			return commit(`vcl/notificationBar/show`, {
				text: `Encountered an error while attempting to subscribe.`,
				type: `warning`
			}, { root: true });
		}

		const result = await response.json();

		commit(`setSubscription`, {
			id: result.id,
			instanceId,
			planId
		});
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while attempting to subscribe.`,
			type: `warning`
		}, { root: true });
	}
}
